export default __webpack_public_path__ + "static/media/lightMan.29aa759d.PNG";